const Instructions = ({ title, instructions, note, titleLeft }) => {
    return (
        <div className="bookingflowpage__instruction__container">
            <h3
                className={`bookingflowpage__instruction__title ${
                    titleLeft ? "text-left" : ""
                }`}
            >
                {title}
            </h3>
            <ol className="bookingflowpage__instruction__subpoint-list">
                {(instructions || []).map((sub, subIdx) => (
                    <li
                        key={subIdx}
                        className="bookingflowpage__instruction__subpoint-item"
                    >
                        {sub}
                    </li>
                ))}
            </ol>
            <p className="bookingflowpage__instruction__note">{note}</p>
        </div>
    );
};

export default Instructions;
